<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #334155 0%, #475569 100%);">
            <i class="fa fa-history text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Histórico do Caixa</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Gestão de históricos e categorias de caixa</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input type="text" ref="edDescricao" v-model="filtrosRapidos.DESCRICAO" placeholder="Buscar por descrição..." class="border-0 bg-transparent" style="width: 250px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span class="d-none d-sm-inline">Novo Histórico</span>
              <span class="d-sm-none">Novo</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="3">
                      <label class="font-weight-bold text-muted small">Tipo</label>
                      <b-form-select v-model="filtrosRapidos.TIPO" :options="[{value: null, text: 'Todos os Tipos'}, {value: 'CREDITO', text: 'CREDITO'}, {value: 'DEBITO', text: 'DEBITO'}, {value: 'COMPENSACAO', text: 'COMPENSACAO'}, {value: 'ACOMPENSAR', text: 'ACOMPENSAR'}]" class="custom-input-premium" @change="pesquisar()"></b-form-select>
                    </b-col>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Status</label>
                      <b-form-select v-model="filtrosRapidos.STATUS" :options="[{value: null, text: 'Todos'}, {value: '1', text: 'Ativo'}, {value: '0', text: 'Inativo'}]" class="custom-input-premium" @change="pesquisar()"></b-form-select>
                    </b-col>
                    <b-col md="3">
                      <label class="font-weight-bold text-muted small">Cód. Completo</label>
                      <b-form-input type="text" v-model="filtrosRapidos.CODIGO_COMPLETO" placeholder="Ex: 2.21" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              class="mb-0 table-finance"
              ref="tbl"
              show-empty
              empty-text="Informe o filtro para ver os registros"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :no-local-sorting="true"
              :busy.sync="isBusy"
              :items="rowsHierarquizados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              :dark="isDark"
              @row-dblclicked="edit"
              @row-clicked="clicarLinha"
              :tbody-tr-class="rowClassSelecionado"
            >
              <!-- Cabeçalhos com Filtro -->
              <template #head(CODIGO_COMPLETO)>
                <SetFilter label="Hierarquia" v-model="filtros.CODIGO_COMPLETO" :options="opcoes.CODIGO_COMPLETO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(DESCRICAO)>
                <SetFilter label="Descrição" v-model="filtros.DESCRICAO" :options="opcoes.DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(TIPO)>
                <SetFilter label="Tipo" v-model="filtros.TIPO" :options="opcoes.TIPO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(AFETA_SALDO)>
                <SetFilter label="Afeta Saldo" v-model="filtros.AFETA_SALDO" :options="opcoes.AFETA_SALDO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(STATUS)>
                <SetFilter label="Status" v-model="filtros.STATUS" :options="opcoes.STATUS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <!-- Hierarquia + caret -->
              <template #cell(CODIGO_COMPLETO)="ctx">
                <span class="mr-1" v-if="ctx.item._temFilhos" style="cursor:pointer"
                      @click.stop="toggle(ctx.item.CODIGO_COMPLETO)">
                  <i class="fa" :class="estaExpandido(ctx.item.CODIGO_COMPLETO) ? 'fa-caret-down' : 'fa-caret-right'"></i>
                </span>
                <span :style="{ paddingLeft: (ctx.item._nivel * 16) + 'px' }">
                  {{ ctx.item.CODIGO_COMPLETO || '-' }}
                </span>
              </template>

              <template #cell(TIPO)="ctx">
                <b-badge pill class="badge-premium shadow-xs" :variant="badgeTipo(ctx.item.TIPO)">{{ ctx.item.TIPO }}</b-badge>
              </template>

              <template #cell(STATUS)="ctx">
                <b-badge pill class="badge-premium shadow-xs" :variant="ctx.item.STATUS === '1' ? 'success' : 'danger'">
                  {{ ctx.item.STATUS === '1' ? 'ATIVO' : 'INATIVO' }}
                </b-badge>
              </template>

              <template #cell(AFETA_SALDO)="ctx">
                <b-badge pill class="badge-premium shadow-xs" :variant="ctx.item.AFETA_SALDO === 'S' ? 'success' : 'secondary'">
                  {{ ctx.item.AFETA_SALDO === 'S' ? 'Sim' : 'Não' }}
                </b-badge>
              </template>

              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="excluirHistorico(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td colspan="6" class="text-left bg-light py-2 px-3">
                    <span class="text-muted small font-weight-bold">Total de registros: {{ rowsHierarquizados.length }}</span>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'

export default {
  components: { SetFilter },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 65,
    useExternalPaging: true,
    filters: [
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
      { key: 'STATUS', type: 'string', label: 'Status', labelMap: { '1': 'Ativo', '0': 'Inativo' } },
      { key: 'TIPO', type: 'string', label: 'Tipo' },
      { key: 'CODIGO_COMPLETO', type: 'string', label: 'Cód. Completo' },
      { key: 'AFETA_SALDO', type: 'string', label: 'Afeta Saldo', labelMap: { 'S': 'Sim', 'N': 'Não' } }
    ]
  })],
  data () {
    return {
      isBusy: false,
      filtroAvancado: false,
      filtrosRapidos: {
        DESCRICAO: '',
        TIPO: null,
        STATUS: null,
        CODIGO_COMPLETO: ''
      },
      colunas: [
        { key: 'CODIGO_COMPLETO', label: 'Hierarquia', sortable: false, class: 'align-middle', thStyle: { width: '22%' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true, class: 'align-middle', thStyle: { width: '40%' } },
        { key: 'TIPO', label: 'Tipo', sortable: true, class: 'align-middle text-center', thStyle: { width: '12%' } },
        { key: 'AFETA_SALDO', label: 'Afeta Saldo', sortable: true, class: 'align-middle text-center', thStyle: { width: '10%' } },
        { key: 'STATUS', label: 'Status', sortable: true, class: 'align-middle text-center', thStyle: { width: '11%' } },
        { key: 'actions', label: 'Ações', class: 'align-middle text-center', thStyle: { width: '5%' } }
      ],
      // 👉 objeto reativo ao invés de Set
      abertos: { '1': true, '2': true, '3': true, '4': true },
      _tick: 0 // força recomputes quando necessário
    }
  },
  mounted() {
    // Sincroniza filtros do store para o local
    this.filtrosRapidos.DESCRICAO = this.DESCRICAO || '';
    this.filtrosRapidos.TIPO = this.TIPO || null;
    this.filtrosRapidos.STATUS = this.STATUS || null;
    this.filtrosRapidos.CODIGO_COMPLETO = this.CODIGO_COMPLETO || '';
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },

    // store bindings
    currentPage: { get () { return this.$store.getters['historico/PAGINA_ATUAL'] }, set (v) { this.$store.commit('historico/SET_PAGINA_ATUAL', v) } },
    perPage: { get () { return this.$store.getters['historico/PER_PAGE'] || 25 }, set (v) { this.$store.commit('historico/SET_PER_PAGE', Number(v) || 25) } },
    lista: { get () { return this.$store.getters['historico/LISTA'] }, set (v) { this.$store.commit('historico/SET_LISTA', v) } },
    DESCRICAO: { get () { return this.$store.getters['historico/DESCRICAO'] }, set (v) { this.$store.commit('historico/SET_DESCRICAO', v) } },
    TIPO: { get () { return this.$store.getters['historico/TIPO'] }, set (v) { this.$store.commit('historico/SET_TIPO', v) } },
    STATUS: { get () { return this.$store.getters['historico/STATUS'] }, set (v) { this.$store.commit('historico/SET_STATUS', v) } },
    CODIGO_COMPLETO: { get () { return this.$store.getters['historico/CODIGO_COMPLETO'] }, set (v) { this.$store.commit('historico/SET_CODIGO_COMPLETO', v) } },

    rowsHierarquizados () {
      const base = (this.lista || []).slice().sort((a, b) =>
        this.compareCodigo(a.CODIGO_COMPLETO, b.CODIGO_COMPLETO)
      )
      const rows = base.map(r => ({
        ...r,
        _nivel: this.nivel(r.CODIGO_COMPLETO),
        _temFilhos: this.temFilhos(r)
      }))

      // dependência reativa: usa _tick para recomputar quando togglar
      void this._tick
      return rows.filter(r => this.visivel(r))
    }

  },
  methods: {
    exportarHtml () {
      printHtmlReport({
        rows: this.rowsHierarquizados,                 // seu array de dados
        columns: this.colunas,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Históricos do Caixa',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: ``,
        pageSize: 'A4',
        landscape: true,                    // vira “deitado” se quiser
        footerTotals: [
          
        ],
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.rowsHierarquizados,
        columns: this.colunas,
        filename: 'historicosCaixa.xls',
        sumKey: null
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.rowsHierarquizados,
        columns: this.colunas,
        filename: 'historicosCaixa.csv',
      });
    },
    compareCodigo(a, b) {
      const sa = (a || '').toString().split('.').filter(Boolean);
      const sb = (b || '').toString().split('.').filter(Boolean);
      const len = Math.max(sa.length, sb.length);
      for (let i = 0; i < len; i++) {
        const va = Number(sa[i] || 0);
        const vb = Number(sb[i] || 0);
        if (va !== vb) return va - vb;       // numérico por segmento
      }
      return sa.length - sb.length;          // pai antes do filho
    },
    nivel(c) {
      const s = (c || '').toString().trim()
      if (!s) return 0
      return s.split('.').filter(Boolean).length - 1
    },

    temFilhos(row) {
      const code = (row.CODIGO_COMPLETO || '').toString()
      if (!code) return false
      return (this.lista || []).some(x => (x.CODIGO_COMPLETO || '').toString().startsWith(code + '.'))
    },

    estaExpandido(code) {
      return !!this.abertos[(code || '').toString()]
    },

    toggle(code) {
      const k = (code || '').toString()
      this.$set(this.abertos, k, !this.abertos[k])   // << reativo
      this._tick++                                    // força recompute
    },

    visivel(row) {
      const code = (row.CODIGO_COMPLETO || '').toString().trim()
      if (!code) return true // linhas sem código: sempre visíveis
      const parts = code.split('.').filter(Boolean)
      let prefix = parts[0] || null
      for (let i = 1; i < parts.length; i++) {
        if (!this.abertos[prefix]) return false
        prefix = `${prefix}.${parts[i]}`
      }
      return true
    },

    badgeTipo (t) {
      if (t === 'CREDITO') return 'success'
      if (t === 'DEBITO') return 'danger'
      if (t === 'COMPENSACAO') return 'warning'
      return 'secondary'
    },

    clicarLinha(item) { this.$store.commit('historico/SET_REGISTRO_SELECIONADO_ID', item.CODIGO) },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['historico/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },

    scrollToSelected() {
      this.$nextTick(() => {
        const selectedRow = this.$el.querySelector('.cec-row-selected');
        if (selectedRow) {
          selectedRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },

    async pesquisar() {
      this.DESCRICAO = this.filtrosRapidos.DESCRICAO;
      this.TIPO = this.filtrosRapidos.TIPO;
      this.STATUS = this.filtrosRapidos.STATUS;
      this.CODIGO_COMPLETO = this.filtrosRapidos.CODIGO_COMPLETO;

      this.$store.commit('controle/setAguardando', true)
      this.isBusy = true
      try { 
        await this.$store.dispatch('historico/GET_LISTA') 
        this.$nextTick(() => {
          this.scrollToSelected();
        });
      }
      finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    limparFiltro() { 
      this.$store.commit('historico/SET_LIMPAR');
      this.filtrosRapidos.DESCRICAO = '';
      this.filtrosRapidos.TIPO = null;
      this.filtrosRapidos.STATUS = null;
      this.filtrosRapidos.CODIGO_COMPLETO = '';
    },
    novo () { this.$router.push(`/cadastros/historico/add`) },
    edit (item) {
      if (['1','2','3',"4"].includes(item.CODIGO_COMPLETO)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é permitido alterar os grupos primários')
        return
      }
      this.$store.commit('historico/SET_REGISTRO_SELECIONADO_ID', item.CODIGO)
      this.$router.push(`/cadastros/historico/edit/${item.CODIGO}`)
    },

    excluirHistorico(item) {
      if (['1','2','3',"4"].includes(item.CODIGO_COMPLETO)) {
         Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é permitido excluir os grupos primários')
         return;
      }

      this.$bvModal.msgBoxConfirm(`Deseja realmente excluir o histórico "${item.DESCRICAO}"?`, {
        title: 'Confirmar Exclusão',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.$http.post('/api/protected/historico/delete', { id: item.CODIGO })
            .then(() => {
                Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Histórico excluído com sucesso!')
                this.pesquisar(); 
            })
            .catch(err => {
              console.error(err);
              Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao excluir histórico.')
            });
        }
      })
      .catch(err => {
        // An error occurred
      });
    },

    expandirTodos() {
      const todos = (this.lista || []).map(r => (r.CODIGO_COMPLETO || '').toString()).filter(Boolean)
      todos.forEach(code => {
        this.$set(this.abertos, code, true)
      })
      this._tick++
    }
  },
  watch: {
    lista: {
      immediate: true,
      handler(arr) {
        const roots = new Set((arr || [])
          .map(r => (r.CODIGO_COMPLETO || '').toString().split('.')[0])
          .filter(Boolean));
        roots.forEach(r => { if (!this.abertos[r]) this.$set(this.abertos, r, true) });
        
        // Se há registro selecionado (vindo de gravação), expande tudo
        const selId = this.$store.getters['historico/REGISTRO_SELECIONADO_ID']
        if (selId) {
          this.$nextTick(() => this.expandirTodos())
        }
      }
    }
  },
  async created() { await this.pesquisar() }
}
</script>

<style scoped>
.list-header-premium {
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.header-icon-wrapper i {
  font-size: 1.5rem;
}

.card-filter-premium {
  background: #f8fafc;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
}

.custom-input-premium {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  transition: all 0.2s;
}

.custom-input-premium:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}

.table-finance {
  font-size: 0.8rem !important;
}

.table-finance >>> thead th {
  background-color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  letter-spacing: 0.05em;
  color: #64748b;
  border-top: none;
  border-bottom: 2px solid #e2e8f0 !important;
  padding: 0.4rem 0.75rem !important;
  position: sticky !important;
  top: 0;
  z-index: 20 !important;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.05);
}

.table-finance >>> tbody td {
  padding: 0.2rem 0.75rem !important;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
}

.badge-premium {
  font-size: 0.7rem !important;
  padding: 0.25rem 0.6rem !important;
  font-weight: 600;
}

.btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-soft-primary {
  background: #eff6ff;
  color: #3b82f6;
  border: none;
}

.btn-soft-primary:hover {
  background: #dbeafe;
  color: #2563eb;
}

.btn-soft-danger {
  background: #fef2f2;
  color: #ef4444;
  border: none;
}

.btn-soft-danger:hover {
  background: #fee2e2;
  color: #dc2626;
}

.shadow-xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }

/* Estilo para linha selecionada */
.table-finance >>> .cec-row-selected {
  background-color: rgba(59, 130, 246, 0.1) !important;
}

.table-finance >>> .cec-row-selected td {
  background-color: transparent !important;
  font-weight: 600;
  color: #1e40af;
}

/* Responsividade do Header Premium */
@media (max-width: 991px) {
  .search-pill-responsive {
    flex-wrap: wrap;
    border-radius: 1rem !important;
    padding: 0.5rem !important;
  }
  
  .search-pill-responsive .px-2 {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  .search-pill-responsive .btn-primary {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .list-header-premium {
    gap: 0.5rem !important;
    padding-bottom: 1rem !important;
  }
  
  .list-header-premium .p-3 {
    padding: 0.75rem !important;
  }
  
  .search-pill-responsive {
    width: 100%;
    margin-right: 0 !important;
    border-radius: 1.5rem !important;
  }
  
  .btn-adicionar-responsive {
    width: 100%;
    margin-top: 0.5rem;
  }
}

@media (max-width: 575px) {
  .header-icon-wrapper {
    width: 38px;
    height: 38px;
  }
  
  .header-text-container h4 {
    font-size: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/historico/HistoricoListagem.vue